"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimTypeIndicatorReferenceSchema = void 0;
exports.claimTypeIndicatorReferenceSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'entityID',
        'userName',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserName',
        'claimTypeIndicator',
        'claimTypeIndicatorDescriptionEN',
        'claimTypeIndicatorDescriptionFR',
    ],
    properties: {
        entityID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        userName: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserName: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        claimTypeIndicator: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        claimTypeIndicatorDescriptionEN: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
        claimTypeIndicatorDescriptionFR: {
            type: 'string',
            errorMessage: 'Should be a string',
        },
    },
};
